import posthog, { type SessionRecordingOptions } from 'posthog-js'

const posthogKey = import.meta.env.VITE_POSTHOG_KEY
const posthogHost = import.meta.env.VITE_POSTHOG_HOST

export const isPostHogEnabled =
  import.meta.env.PROD && Boolean(posthogKey && posthogHost)

const sessionRecordingWithCanvas = {
  captureCanvas: {
    canvasFps: 4,
    canvasQuality: '0.4',
  },
} as SessionRecordingOptions

/**
 * Pinned to 1.105.7 for session replay canvas capture.
 * Enable canvas recording in PostHog project settings (Session replay).
 */
if (isPostHogEnabled) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    capture_pageleave: true,
    capture_pageview: false,
    session_recording: sessionRecordingWithCanvas,
  })
}

export { posthog }
